import { type FC } from "react";
import { Stack } from "@mui/material";
import { FilterProvider } from "@/partner/shared/components/Filter";
import { TagsFilter } from "./TagsFilter";
import { TagsList } from "./TagsList";
import { CreateTagDialog } from "./CreateTagDialog";
import { EditTagDialog } from "./EditTagDialog";
import { useSearchParams } from "react-router-dom";
import qs from "qs";

export const Tags: FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const {
    tab,
    id: tagId,
    filter,
  } = qs.parse(searchParams.toString(), {
    ignoreQueryPrefix: true,
  }) as { tab?: string; id?: string; filter?: { typeId?: string } };
  // Список отфильтрован по типу (вкладка «Актёры» и т.п.): новый тег
  // создаётся сразу этого типа, и форма открывает слот картинки, который
  // у типа основной.
  const filterTypeId = filter?.typeId || null;

  const handleEdit = (id: string) => {
    searchParams.set("tab", "edit");
    searchParams.set("id", id);
    setSearchParams(searchParams);
  };

  const handleCreate = () => {
    searchParams.set("tab", "create");
    setSearchParams(searchParams);
  };

  const handleCloseCreateDialog = () => {
    searchParams.delete("tab");
    setSearchParams(searchParams);
  };

  const handleCloseEditDialog = () => {
    searchParams.delete("tab");
    searchParams.delete("id");
    setSearchParams(searchParams);
  };

  return (
    <FilterProvider>
      <Stack spacing={1}>
        <TagsFilter onCreateTag={handleCreate} />
        <TagsList onEditTag={handleEdit} />
      </Stack>

      <CreateTagDialog
        open={tab === "create"}
        initialTypeId={filterTypeId}
        onClose={handleCloseCreateDialog}
        onCompleted={handleCloseCreateDialog}
      />

      <EditTagDialog
        open={tab === "edit"}
        tagId={tagId ?? null}
        onClose={handleCloseEditDialog}
        onCompleted={handleCloseEditDialog}
      />
    </FilterProvider>
  );
};
